import { App } from "antd";
import { gstate } from "./gstate";

export let message, notification, modal;

export function PopUpContext() {
  const func = App.useApp();
  message = func.message;
  notification = func.notification;
  modal = func.modal;
  return null;
}

export function showSuccess(result = "成功") {
  message.success(result);
}

export function showError(result = "失败") {
  message.error(result);
}

export function showLoading(tip) {
  gstate.loading = true;
  gstate.loadingTip = tip;
  return () => {
    gstate.loading = false;
    gstate.loadingTip = undefined;
  };
}
